import { Divider, Checkbox, Popover, Select } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { ResponsiveActionIconButton } from "./responsive-action-icon-button"
import { IconFilter } from "@tabler/icons-react"
import { WorkareaFilter } from "./workarea-filter"
import { SimpleWorkArea } from "../../../../../@client/Theasoft_ApiServer_WorkAreas"
import { useGetQuickSelectSeasons } from "../../../../../blocks/seasons/use-get-seasons"
import { useSuspenseQueryGet } from "../../../../../typed-client/hooks/use-suspense-query-get"
import { ScrollContainer } from "../../../../../-components/scroll-container"

export function ShowCanceledActivitiesCheckbox({
  onChange,
  checked,
}: {
  checked: boolean
  onChange: (v: boolean) => void
}) {
  const { t } = useTranslation("app_server")
  return (
    <Checkbox
      label={t("ShowCanceledActivities")}
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
    />
  )
}

type Props = {
  workareas: SimpleWorkArea[]
  onSetSelectedWorkareaIds: (
    selectedWorkareaIds: number[] | null | undefined
  ) => void
  selectedWorkareaIds: number[] | null
  showCanceledActivities: boolean
  setShowCanceledActivities: (v: boolean) => void
  selectedProduction: number | null
  setSelectedProduction: (v: number | null) => void
}

export function ProductionSelect(props: {
  selectedProduction: number | null
  setSelectedProduction: (v: number | null) => void
}) {
  const { data: seasons } = useGetQuickSelectSeasons()
  const { data } = useSuspenseQueryGet("/api/Production/GetList", {
    searchString: "",
    seasonIds: seasons.map((v) => v.seasonId),
    genreTreeNodes: [],
    firstItem: 0,
    pageSize: 100,
  })
  return (
    <Select
      size="lg"
      variant="unstyled"
      style={{ border: "none" }}
      placeholder="Alle Produktionen"
      value={
        props.selectedProduction === null
          ? null
          : props.selectedProduction.toString() || null
      }
      onChange={(v) => {
        if (v !== null) {
          props.setSelectedProduction(parseInt(v))
        } else {
          props.setSelectedProduction(null)
        }
      }}
      data={data.data.map((v) => ({
        label: v.title,
        value: v.id.toString(),
      }))}
    />
  )
}

export function Filter(props: Props) {
  const filteredWorkAreaIds = props.selectedWorkareaIds
  const filtersAreActive =
    filteredWorkAreaIds &&
    filteredWorkAreaIds.length > 0 &&
    filteredWorkAreaIds.length !== props.workareas.length

  const { t } = useTranslation("app_server")

  return (
    <Popover>
      <Popover.Target>
        <ResponsiveActionIconButton
          actionIconProps={{
            variant: filtersAreActive ? "outline" : "default",
          }}
          buttonProps={{
            size: "xs",
            variant: filtersAreActive ? "outline" : "default",
            children: `Filter ${
              filtersAreActive ? ` (${filteredWorkAreaIds!.length})` : ""
            }`,
          }}
          icon={<IconFilter size={16} />}
        />
      </Popover.Target>
      <Popover.Dropdown>
        <ScrollContainer mah={"50vh"}>
          <Divider label={t("Activities")} />
          <ShowCanceledActivitiesCheckbox
            checked={props.showCanceledActivities}
            onChange={(v) => {
              props.setShowCanceledActivities(v)
            }}
          />
          <Divider label={t("Instruments")} />
          <WorkareaFilter
            workareas={props.workareas}
            onSetSelectedWorkareaIds={props.onSetSelectedWorkareaIds}
            selectedWorkareaIds={props.selectedWorkareaIds}
          />
        </ScrollContainer>
      </Popover.Dropdown>
    </Popover>
  )
}
